import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SidebarItemComponent } from '@app/shell/components/sidebar-item/sidebar-item.component';
import { MenuGroups } from '@app/shell/models/sidebar.models';
import { SidebarService } from '@app/shell/services/sidebar.service';
import { APP_CONFIG, BaseAppConfig } from '@avenir-client-web/models';
import { AppActionRoute, AppRootRoute } from '@core/enums/app-route.enum';
import { Permission } from '@core/services/permission.model';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SidebarModule } from 'primeng/sidebar';
import { Observable, repeatWhen, share } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    SidebarModule,
    NgxPermissionsModule,
    SidebarItemComponent,
  ],
})
export class SideBarComponent implements OnInit {
  isDisplay = false;

  permission = Permission;

  sidebarItems$: Observable<MenuGroups>;

  appSettings = this.config.appSettings;

  constructor(
    @Inject(APP_CONFIG) readonly config: BaseAppConfig,
    private readonly sidebarService: SidebarService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.setSidebarItems();
  }

  toggleSidebar(isDisplay: boolean): void {
    this.isDisplay = isDisplay;
  }

  isCategoryFormRouter(): boolean {
    return (
      this.router.url ===
      `/${AppRootRoute.ADMIN_CONTENT_CATEGORIES}/${AppActionRoute.CREATE}`
    );
  }

  private setSidebarItems(): void {
    const menuChangedNotifier = (): Observable<void> =>
      this.sidebarService.menuChangedEvent$.asObservable();

    this.sidebarItems$ = this.sidebarService
      .getSidebarItems()
      .pipe(repeatWhen(menuChangedNotifier), share());
  }
}
